// Note: This is norsk bokmål
export const no = {
  locale: "no",

  Main: {
    title: "Din profil",
    description:
      "Administrer og få en oversikt over dine personlige opplysninger og kontopreferanser.",
    edit: "Rediger",
    logout: "Logg ut",
  },

  AccountPreferences: {
    title: "Kontoinnstillinger",
    description: "Tilpass innstillinger knyttet til din konto.",
  },

  DeleteUser: {
    title: "Slett brukerkonto",
    description: "Sletter kontoen permanent. Handlingen kan ikke angres",
    editLabel: "Slett konto",
  },

  DeleteUserDialog: {
    title: "Slett brukerkonto",
    description:
      "Er du sikker på at vil slette kontoen? Handlingen kan ikke angres.",
    deleted_description:
      "Du har slettet kontoen din og har ikke tilgang til denne siden lenger.",
    cancel: "Avbryt",
    submitLabel: "Slett konto",
    saveError:
      "Det oppstod en feil ved sletting av din konto. Vennligst prøv igjen senere.",
  },

  Details: {
    title: "Detaljer",
    description: "Administrer din personlige informasjon.",
  },

  EditNameDialog: {
    title: "Endre navn",
    description: "Skriv inn det nye navnet ditt nedenfor.",
    firstNameLabel: "Fornavn",
    lastNameLabel: "Etternavn",
    cancel: "Avbryt",
    submitLabel: "Endre navn",
    saveError:
      "Det oppstod en feil ved endring av navnet ditt. Vennligst prøv igjen senere.",
  },

  Profile: {
    title: "Din profilinformasjon",
    description: "Dette er deg.",
    nameLabel: "Navn",
    emailLabel: "E-post",
  },

  LoginDialog: {
    title: "Brukerprofil",
    // description:
    //   "Logg inn for å endre konto-informasjon eller for å slette din bruker",
    email: "E-post",
    password: "Passord",
    login: "Logg inn",
    loginError: "Kunne ikke logge inn med angitt e-post/passord.",
    sessionExpired: "Økten din har utgått, og du har blitt logget ut",
    switchUser: "Bytt bruker",
    loggedInAs: "Logged in as: ",
  },
};

export type Lang = typeof no;
